const qs = require('qs')

export const getQueryString = (options) => {
    const obj ={
        ...options
    }
    const result = qs.stringify(obj,{
        encodeValuesOnly:true
    })
    return result 
}

export const queryStringForSearch=(query) =>{

    const queryString = query?.toLowerCase()
    const obj = {
        filters: {
            $or: [
                {
                    courseTitle: {
                        $containsi: queryString,
                    },
                },
                {
                    instructors: {
                        instructorName: {$containsi: queryString},
                    },
                },
            ],
        },
    }
    const result = qs.stringify(obj)
    return result 
}

export const getLimitedQueryString = (queryStr='',queryObj,omitKeys=[]) => {
    for(let key in omitKeys){
        const _key = omitKeys[key];
        const queryKeyVal = queryObj.get(_key); // not a json object
        queryStr = queryStr?.replace(`&${_key}=${queryKeyVal}`,'')?.replace(`${_key}=${queryKeyVal}`,'')
    }
    return queryStr
}
